import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { sortBy as _sortBy, sortedUniqBy as _sortedUniqBy } from 'lodash';

import { AutoPolicy, Discount, Policy, Risk, Vehicle } from '@amfam/policy/models';

@Component({
  selector: 'policy-discounts',
  templateUrl: './discounts.component.html',
  styleUrls: ['./discounts.component.scss'],
  standalone: false
})
export class DiscountsComponent implements OnInit, OnChanges {
  private index: number;
  public discountDescriptions = new Array<String>();
  public discounts = new Array<Discount>();
  public canShowTotalPremium = true;
  vehicleDiscounts: string[] = [];
  premium: string;
  term: string;

  @Input() policy: Policy;
  @Input() vehicleId?: string;

  constructor() {}

  ngOnInit() {
    let actualPremium = 0;
    if (this.policy instanceof AutoPolicy) {
      this.policy.policyRisks.forEach(risk => {
        const vehicle = risk as Vehicle;
        actualPremium += parseFloat(vehicle.premium);
      });
      this.canShowTotalPremium = Number(this.policy.totalPremium) === Number(actualPremium);
    }
  }

  ngOnChanges() {
    this.discountDescriptions = [];
    this.discounts.length = 0;
    this.vehicleDiscounts.length = 0;
    let discounts = new Array<Discount>();
    // Aggregate discounts for auto by vehicle
    if (this.policy instanceof AutoPolicy) {
      const vehicles = this.policy.vehicles.filter(v => v.vehicleId === this.vehicleId);
      for (const vehicle of vehicles) {
        for (const vehicleDiscount of vehicle.vehicleDiscounts) {
          discounts.push({ ...vehicleDiscount, vehicleId: vehicle.vehicleId });
        }
      }
    }

    // check for regular discounts
    if (this.policy.policyDiscounts) {
      for (const discount of this.policy.policyDiscounts) {
        discounts.push(discount);
      }
    }

    discounts = _sortBy(discounts, 'description');
    this.discounts = _sortedUniqBy(discounts, 'description');

    this.discounts.forEach(discount => {
      this.index = discount.description.toLowerCase().lastIndexOf('discount');
      if (this.index === -1) {
        this.discountDescriptions.push(discount.description);
      } else {
        this.discountDescriptions.push(discount.description.substring(0, this.index).trim());
      }
    });
    this.discountDescriptions.sort();
    this.setPremium();
    this.setDiscountsForVehicle();
  }

  hasPremium(risk: Risk) {
    return risk instanceof Vehicle;
  }

  private setPremium() {
    if (this.policy instanceof AutoPolicy) {
      const vehicle = this.policy.vehicles.find(v => v.vehicleId === this.vehicleId);
      if (vehicle) this.premium = vehicle.premium;
    } else {
      this.premium = String(this.policy.totalPremium);
    }
  }

  private setDiscountsForVehicle() {
    if (this.policy instanceof AutoPolicy) {
      if (this.vehicleId && this.discounts?.length > 0) {
        const vehicleDiscounts = this.discounts.filter(
          d => d.vehicleId && d.vehicleId === this.vehicleId
        );
        if (this.policy.policyDiscounts) {
          for (const discount of this.policy.policyDiscounts) {
            vehicleDiscounts.push(discount);
          }
        }
        vehicleDiscounts.forEach(discount => {
          this.index = discount.description.toLowerCase().lastIndexOf('discount');
          if (this.index === -1) {
            this.vehicleDiscounts.push(discount.description);
          } else {
            this.vehicleDiscounts.push(discount.description.substring(0, this.index).trim());
          }
        });
        this.discountDescriptions = this.vehicleDiscounts;
        this.discountDescriptions.sort();
      }
    }
  }
}
